import types from "../actions/types";

const defaultState = {
  dataShinhan: [],
};

export default (state = defaultState, action: any) => {
  switch (action.type) {
    case types.GET_DATA_SHINHAN:
      return {
        ...state,
        dataShinhan: action.dataShinhan,
      };
    default:
      return state;
  }
};
